import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, tap } from 'rxjs';

import { ApiService } from '../api/api.service';
import { ApiResult } from '../models/api/api-result.model';
import { LoginRequestModel } from '../models/AuthModels/login-request.model';
import { JwtTokenResultModel } from '../models/AuthModels/jwt-token-result.model';
import { AnametaOneRegisterModel } from '../models/Register/anameta-one-register.model';
import { AccountModel } from '../models/Register/AccountModel.model';
import { LoginResponseModel } from '../models/Register/LoginResponseModel.model';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  public static readonly tokenKey = 'access_token';

  constructor(private readonly apiService: ApiService, private readonly router: Router) {
  }


    Register(model:AnametaOneRegisterModel): Observable<ApiResult<LoginResponseModel>> {

      return this.apiService.post<LoginResponseModel, AnametaOneRegisterModel>('register', model);
 

  }


  Login(email:string, password:string): Observable<ApiResult<JwtTokenResultModel>> {

       const model: LoginRequestModel = {
       email: email,
       password: password,
      Recaptcha:""
      };


    return this.apiService.post<JwtTokenResultModel, LoginRequestModel>('login', model).pipe(
      tap((response) => {
        if (!response.isError && response.data?.accessToken) {
          this.saveToken(response.data.accessToken);
        }
      })
    );
  }

  public getUserId(): string | null {
    const payload = this.getTokenPayload();

    return payload?.['nameid'] ?? null;
  }

  public getUserEmail(): string | null {
    const payload = this.getTokenPayload();

    return payload?.['email'] ?? null;
  }

  public isLoggedIn(): boolean {
    return Boolean(this.getToken());
  }

  public isAccessTokenValid(): boolean {
    const token = this.getToken();

    if (!token) {
      return false;
    }

    const payload = this.getTokenPayload();

    if (!payload) {
      return false;
    }

    const exp = payload['exp'];

    if (!exp || typeof exp !== 'number') {
      return false;
    }

    const currentUnixTime = Math.floor(Date.now() / 1000);

    if (exp <= currentUnixTime) {
      return false;
    }

    return true;
  }

  public getToken(): string | null {
    return localStorage.getItem(AuthService.tokenKey);
  }

  public saveToken(token: string): void {
    localStorage.setItem(AuthService.tokenKey, token);
  }

  public logout(): void {
    localStorage.removeItem(AuthService.tokenKey);
  }

  public forceLogout(): void {
    this.logout();
    this.router.navigate(['/login']);
  }

  private getTokenPayload(): Record<string, any> | null {
    const token = this.getToken();

    if (!token) {
      return null;
    }

    try {
      const parts = token.split('.');

      if (parts.length !== 3) {
        return null;
      }

      const payload = parts[1];

      if (!payload) {
        return null;
      }

      const base64 = payload
        .replace(/-/g, '+')
        .replace(/_/g, '/');

      const paddedBase64 = base64.padEnd(
        base64.length + (4 - base64.length % 4) % 4,
        '='
      );

      return JSON.parse(atob(paddedBase64));
    }
    catch {
      return null;
    }
  }
}